module.exports = __webpack_public_path__ + "static/media/levels_2_3.78fd6977.svg";